module.exports = __webpack_public_path__ + "img/40447682.09e075a2.png";